<template>
  <div class="copyright">
    <p>Copyright &copy; {{new Date().getFullYear()}} bakerychina.com All Rights Reserved.</p>
    <!-- <p>沪ICP备09006318号</p> -->
  </div>
</template>

<script>
export default {
  name: "copyright"
};
</script>

<style scoped lang="scss">
.copyright {   
  width: 100%;
  margin: 20px;
  color: #aaa;
  font-size: 12px;  
  text-align: center; 
  p {
    opacity: 0.7;
    margin: 0;
  }
}
</style>
